import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/common';
import SupplierForm from '../SupplierForm';
import { useUIStore } from '@/store/uiStore';
import { toast } from '@/store/toastStore';
import { supplierApi } from '@/api/endpoints/suppliers';
import { CreateSupplierRequest } from '@/types/supplier';

const CreateSupplierModal: React.FC = () => {
  const { t } = useTranslation();
  const { modals, closeModal, refreshCallbacks } = useUIStore();
  const [loading, setLoading] = useState(false);

  const isOpen = modals.createSupplier;

  const handleSubmit = async (data: CreateSupplierRequest) => {
    setLoading(true);
    try {
      await supplierApi.createSupplier(data);

      toast.success('Success', t('suppliers.createSuccess'));
      
      // Trigger refresh in parent component
      refreshCallbacks.suppliers?.();
      
      closeModal('createSupplier');

      // Emit custom event to refresh supplier list
      window.dispatchEvent(new CustomEvent('supplier-updated'));

    } catch (error: any) {
      console.error('Error creating supplier:', error);
      const errorMessage = error.message || 'Failed to create supplier';
      toast.error('Error', errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    closeModal('createSupplier');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title={t('tooltips.suppliers.newSupplier')}
      size="xl"
      closeOnOverlayClick={!loading}
      closeOnEscape={!loading}
    >
      <SupplierForm
        onSubmit={handleSubmit as any}
        onCancel={handleCancel}
        loading={loading}
      />
    </Modal>
  );
};

export default CreateSupplierModal;
